export default "__VITE_PUBLIC_ASSET__83df4e32__"